import React from 'react';
import { PhoneIcon, ArrowRightIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
interface CTARowProps {
  className?: string;
  align?: 'left' | 'center';
}
export function CTARow({
  className = '',
  align = 'left'
}: CTARowProps) {
  return <div className={`flex flex-col sm:flex-row gap-4 ${align === 'center' ? 'justify-center' : 'justify-start'} ${className}`} data-id="element-24">
      <Button variant="primary" size="lg" className="w-full sm:w-auto flex items-center justify-center gap-2 shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-0.5" onClick={() => window.location.href = 'tel:6233000708'} data-id="element-25">
        <PhoneIcon className="w-5 h-5" data-id="element-26" />
        <span data-id="element-27">Call the AI Demo Now</span>
      </Button>

      <Button variant="secondary" size="lg" className="w-full sm:w-auto flex items-center justify-center gap-2" onClick={() => window.open('https://api.viridiaanalytics.com/payment-link/699612346c8c04e29116c945', '_blank')} data-id="element-28">
        <span data-id="element-29">Get Started for $697/month Today</span>
        <ArrowRightIcon className="w-5 h-5" data-id="element-30" />
      </Button>
    </div>;
}